<glxy-page>
  <glxy-page-toolbar>
    <glxy-page-title>
      {{ 'ACQUISITION_WIDGETS.TITLE' | translate }}
    </glxy-page-title>
    <glxy-page-actions>
      <ng-container *ngIf="hasMarketsAccess$ | async">
        <glxy-form-field class="market-selector" [bottomSpacing]="false" *ngIf="markets?.length > 1">
          <mat-select placeholder="Market" (selectionChange)="changeMarket($event.value)">
            <mat-option *ngFor="let m of markets" [value]="m.market_id">
              {{ m.name }}
            </mat-option>
          </mat-select>
        </glxy-form-field>
      </ng-container>
      <a mat-flat-button color="primary" id="create-widget" href="/marketing/widget/wizard/">Create widget</a>
    </glxy-page-actions>
  </glxy-page-toolbar>

  <glxy-page-wrapper>
    <ng-container *ngIf="allMarketsWidgets$ | async as allMarketsWidgets; else loading">
      <div class="table-container mat-elevation-z0" *ngIf="allMarketsWidgets?.length > 0; else emptyState">
        <va-table
          content
          [items]="widgets$ | async"
          [tableViewModel]="acquisitionWidgetTable"
          [showLoadMore]="hasMore$ | async"
          [loadingMore]="loadingMore$ | async"
        ></va-table>
      </div>
    </ng-container>
  </glxy-page-wrapper>
</glxy-page>

<ng-template #emptyState>
  <glxy-empty-state>
    <glxy-empty-state-hero>
      <img [src]="getImageSrc('images/empty-state/widgets-empty-state.png')" alt="Widgets Empty State" />
    </glxy-empty-state-hero>
    <glxy-empty-state-title>
      {{ 'ACQUISITION_WIDGETS.EMPTY_STATE.TITLE' | translate }}
    </glxy-empty-state-title>
    <p>
      {{ 'ACQUISITION_WIDGETS.EMPTY_STATE.DESCRIPTION' | translate }}
    </p>
    <glxy-empty-state-actions>
      <a mat-flat-button color="primary" (click)="navigateToURL('/marketing/widget/wizard')">
        {{ 'ACQUISITION_WIDGETS.EMPTY_STATE.CTA' | translate }}
      </a>
    </glxy-empty-state-actions>
  </glxy-empty-state>
</ng-template>

<ng-template #loading>
  <glxy-loading-spinner [size]="'large'" [fullWidth]="true"></glxy-loading-spinner>
</ng-template>
